// extracted by mini-css-extract-plugin
export default {"auth-page__window":"dZgY63Ff1ZZM71m3tF1x","authPageWindow":"dZgY63Ff1ZZM71m3tF1x"};